import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";

export function GestionTiendasPersonalViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {
    const canales = record[3] as string;
    const cadena = record[4] as string;
    const tienda = record[5] as string;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena} - ${tienda}`,
        assignColorByValue: undefined,
        fillColor: theme.colors.gray[8],
    }

    return markerProps;
}